module.exports = __webpack_public_path__ + "img/price-quote2.6e2803cf.png";